import { Outlet } from 'react-router-dom';
import AuthGuard from '@/components/feature/AuthGuard';

export default function MemberAuthGuardLayout() {
  return (
    <AuthGuard allowedRoles={['landowner', 'tenant', 'viewer']} redirectTo="/members">
      <Outlet />
    </AuthGuard>
  );
}